type NewspaperColors = {
  header: string;
  paper: string;
  accent: string;
  line: string;
  detail: string;
  shadow: string;
  foldShadow: string;
};

const DEFAULT_COLORS: NewspaperColors = {
  header: '#232326',
  paper: '#FFFFFF',
  accent: '#9E3D4B',
  line: '#B7B2B2',
  detail: '#3B3B42',
  shadow: '#050101',
  foldShadow: '#3B3B42',
};

const WATERMARK_LIGHT_COLORS: NewspaperColors = {
  header: '#0EA5E9',
  paper: '#BAE6FD',
  accent: '#0284C7',
  line: '#7DD3FC',
  detail: '#38BDF8',
  shadow: '#0EA5E9',
  foldShadow: '#0369A1',
};

const WATERMARK_DARK_COLORS: NewspaperColors = {
  header: '#0284C7',
  paper: '#082F49',
  accent: '#0369A1',
  line: '#0369A1',
  detail: '#0EA5E9',
  shadow: '#0284C7',
  foldShadow: '#0369A1',
};

type ScanReceiptNewspaperIconProps = {
  className?: string;
  variant?: 'default' | 'watermark';
};

const renderNewspaper = (colors: NewspaperColors) => (
  <g>
    <g>
      <path
        fill={colors.header}
        d="M506.607,12.439v11.656c0,6.871-5.567,12.44-12.352,12.44H12.352C5.567,36.535,0,30.966,0,24.095
			V12.439C0,5.567,5.567,0,12.352,0h481.903c4.088,0,7.742,2.001,9.917,5.132c0.348,0.435,0.609,0.871,0.87,1.305
			c0.087,0.174,0.261,0.434,0.348,0.608c0.174,0.261,0.261,0.609,0.435,0.958c0.174,0.521,0.348,0.956,0.348,1.478
			C506.52,10.439,506.607,11.395,506.607,12.439z"
      />
      <polygon
        fill={colors.paper}
        points="485.034,19.224 485.034,512 469.377,512 465.028,500.779 427.015,500.779 422.666,512 
			392.307,512 387.958,500.779 349.945,500.779 345.596,512 315.237,512 310.801,500.779 272.875,500.779 268.439,512 238.168,512 
			233.732,500.779 195.806,500.779 191.369,512 161.011,512 156.662,500.779 118.649,500.779 114.3,512 83.942,512 79.592,500.779 
			41.58,500.779 37.23,512 21.572,512 21.572,19.224"
      />
      <g>
        <path
          fill={colors.accent}
          d="M121.259,142.048c-0.435-0.521-1.044-0.783-1.827-0.783c-0.695,0-1.304,0.261-1.913,0.783
				c-0.435,0.348-0.87,1.392-1.392,3.045c-0.783,2.609-2.609,3.914-5.567,3.914c-2.784,0-5.393-1.305-7.829-4.001
				c-3.218-3.741-6.35-10.091-9.395-19.138c-1.304-3.914-2.261-6.611-2.957-8.263c-0.348-0.957-1.218-2.87-2.609-5.654
				c5.567-0.87,9.916-2.958,13.134-6.089c3.132-3.22,4.785-6.698,4.785-10.439c0-3.914-1.74-6.871-5.22-8.959
				c-3.479-2.001-7.915-2.958-13.309-2.958c-5.741,0-11.222,1.305-16.44,3.914c-5.219,2.61-9.133,5.915-11.656,9.918
				c-2.61,4.001-3.827,8.35-3.827,13.048c0,3.566,0.783,6.611,2.436,9.133c1.305,1.913,2.697,2.87,4.349,2.87
				c0.696,0,1.218-0.261,1.74-0.696c0.435-0.521,0.695-1.044,0.695-1.653c0-0.521-0.174-1.043-0.435-1.478
				c-0.261-0.435-0.957-1.218-2.175-2.175c-2.262-2-3.479-4.436-3.479-7.22c0-3.74,1.131-7.307,3.392-10.699
				c2.262-3.391,5.654-6.263,10.178-8.524c4.523-2.262,9.133-3.479,13.918-3.479c3.653,0,6.611,0.956,8.786,2.783
				c2.175,1.739,3.218,4.088,3.218,6.871c0,3.654-1.305,6.785-4.002,9.395c-2.697,2.697-5.915,4.001-9.742,4.001
				c-0.957,0-2.175-0.174-3.653-0.435l3.393-13.395c0.609-2.262,1.044-3.915,1.392-5.045c-4.262,1.043-7.828,1.652-10.873,1.652
				l-0.609,2.175c1.131,0,1.827,0.087,2.262,0.348c0.348,0.261,0.522,0.695,0.522,1.217c0,0.61-0.348,2.523-1.131,5.743
				l-6.35,25.312c-0.783,3.218-2.001,5.48-3.48,6.785c-1.044,0.87-3.131,1.652-6.524,2.523l-0.609,2.522
				c3.131-0.696,5.915-1.044,8.35-1.044c1.305,0,2.958,0.087,5.045,0.348c2.262,0.174,4.001,0.261,5.132,0.261
				c1.131,0,2.697-0.174,4.698-0.609l0.522-2.175c-2.001,0.435-3.653,0.609-4.958,0.609c-0.87,0-2-0.087-3.48-0.261l6.089-24.095
				c0.522,0,0.87-0.087,1.131-0.087l1.131,0.087c0.261,0.782,0.957,2.957,2.088,6.611c1.74,6.089,3.131,10.264,4.089,12.525
				c1.826,4.523,4.088,8.35,6.611,11.57c2.436,3.218,5.045,5.566,7.742,6.959c2.697,1.391,5.48,2.088,8.438,2.088
				c3.218,0,5.828-0.784,7.915-2.523c2.001-1.653,3.045-3.48,3.045-5.307C122.042,143.179,121.78,142.483,121.259,142.048z"
        />
        <path
          fill={colors.accent}
          d="M130.827,117.431c3.48-2,5.915-4.002,7.307-5.915c1.305-1.913,2-3.827,2-5.74
				c0-1.913-0.522-3.393-1.653-4.436c-1.131-1.045-2.784-1.653-4.958-1.653c-6.089,0-11.395,3.654-15.744,10.96
				c-4.001,6.351-5.915,12.788-5.915,19.312c0,3.13,0.522,5.479,1.653,6.958c1.131,1.392,2.784,2.175,4.958,2.175
				c5.306,0,11.656-3.567,19.05-10.612l-1.566-1.915c-3.827,2.784-6.698,4.698-8.699,5.655c-1.479,0.694-2.871,1.043-4.089,1.043
				c-1.304,0-2.261-0.434-2.957-1.217c-0.696-0.871-1.044-2.349-1.044-4.523c0-1.479,0.174-3.045,0.435-4.698
				C125.347,120.301,129.088,118.475,130.827,117.431z M123.085,109.776c0.957-2.262,2.175-3.914,3.566-5.046
				c1.044-0.869,2.175-1.217,3.306-1.217c1.044,0,1.913,0.348,2.609,1.13c0.696,0.784,1.044,1.827,1.044,3.132
				c0,1.652-0.87,3.391-2.522,5.132c-2.436,2.523-6.089,4.871-10.96,7.045C120.737,116.562,121.693,113.169,123.085,109.776z"
        />
        <path
          fill={colors.accent}
          d="M173.885,101.078c-1.131-0.87-2.871-1.305-5.045-1.305c-3.566,0-6.785,1.044-9.655,3.131
				c-3.566,2.697-6.698,6.611-9.221,11.657c-2.522,5.045-3.74,9.915-3.74,14.7c0,2.784,0.522,5.046,1.653,6.872
				c0,0.087,0.087,0.087,0.087,0.174c1.218,1.913,3.131,2.87,5.741,2.87c4.958,0,11.047-2.87,18.18-8.524l-0.957-2.61
				c-4.871,4.089-9.047,6.177-12.613,6.177c-1.479,0-2.609-0.609-3.393-1.827c-0.435-0.608-0.87-1.392-1.131-2.262
				c-0.435-1.218-0.609-2.696-0.609-4.349c0-3.914,0.696-7.742,2.001-11.656c1.305-3.827,2.697-6.437,4.175-7.742
				c1.479-1.392,2.957-2.088,4.436-2.088c1.131,0,2.609,0.521,4.262,1.566c1.74,0.956,3.044,1.478,4.088,1.478
				c1.131,0,2.001-0.348,2.523-0.87c0.609-0.608,0.957-1.392,0.957-2.349C175.625,102.991,175.016,101.947,173.885,101.078z"
        />
        <path
          fill={colors.accent}
          d="M198.502,117.431c3.48-2,5.915-4.002,7.307-5.915c1.305-1.913,2.001-3.827,2.001-5.74
				c0-1.913-0.522-3.393-1.653-4.436c-1.131-1.045-2.784-1.653-4.958-1.653c-6.089,0-11.395,3.654-15.832,10.96
				c-3.914,6.351-5.828,12.788-5.828,19.312c0,3.13,0.522,5.479,1.653,6.958c1.131,1.392,2.784,2.175,4.958,2.175
				c5.219,0,11.569-3.567,18.963-10.612l-1.479-1.915c-3.827,2.784-6.698,4.698-8.699,5.655c-1.479,0.694-2.87,1.043-4.088,1.043
				c-1.305,0-2.262-0.434-2.958-1.217c-0.695-0.871-1.044-2.349-1.044-4.523c0-1.479,0.174-3.045,0.435-4.698
				C193.022,120.301,196.762,118.475,198.502,117.431z M190.76,109.776c0.957-2.262,2.175-3.914,3.567-5.046
				c1.044-0.869,2.175-1.217,3.218-1.217c1.131,0,2.001,0.348,2.697,1.13c0.696,0.784,1.044,1.827,1.044,3.132
				c0,1.652-0.87,3.391-2.523,5.132c-2.435,2.523-6.089,4.871-10.96,7.045C188.412,116.562,189.369,113.169,190.76,109.776z"
        />
        <path
          fill={colors.accent}
          d="M231.47,128.305c-3.915,3.741-6.437,5.654-7.394,5.654c-0.261,0-0.435-0.174-0.696-0.435
				c-0.174-0.261-0.261-0.61-0.261-1.044c0-2.262,1.566-8.699,4.784-19.398c1.913-6.524,2.871-10.265,2.871-11.134
				c0-0.696-0.261-1.305-0.783-1.739c-0.435-0.435-1.218-0.608-2.175-0.608c-1.74,0-3.827,0.694-6.35,2.088
				c-2.523,1.391-5.219,3.74-8.264,7.132l2,1.479c2.697-2.61,4.349-4.089,5.132-4.61c0.783-0.435,1.479-0.697,2.088-0.697
				c0.522,0,0.783,0.261,0.783,0.871c0,0.521-0.087,1.217-0.348,1.913c-4.523,14.613-6.785,23.834-6.785,27.661
				c0,1.132,0.348,2.088,0.957,2.697c0.609,0.695,1.479,1.044,2.522,1.044c1.218,0,2.784-0.608,4.698-1.653
				c1.826-1.043,4.871-3.566,9.046-7.48L231.47,128.305z M235.297,81.245c-0.609-0.608-1.392-0.87-2.262-0.87
				c-1.217,0-2.261,0.434-3.131,1.392c-0.87,0.957-1.304,2.088-1.304,3.479c0,1.045,0.261,1.827,0.87,2.436
				c0.609,0.697,1.392,0.958,2.262,0.958c1.131,0,2.175-0.435,3.131-1.479c0.87-1.044,1.392-2.175,1.392-3.48
				C236.254,82.724,235.906,81.854,235.297,81.245z"
        />
        <path
          fill={colors.accent}
          d="M273.919,101.86c-1.044-1.392-2.348-2.175-3.914-2.175c-2.348,0-4.958,0.957-7.741,2.783
				c-1.74,1.132-4.871,3.915-9.482,8.613c1.044-3.48,1.653-5.654,1.827-6.611c0.174-0.87,0.348-1.827,0.348-2.696
				c0-0.697-0.261-1.219-0.696-1.653c-0.435-0.348-1.044-0.521-1.826-0.521c-1.914,0-4.349,0.782-7.046,2.348
				c-2.697,1.566-5.393,4.002-8.177,7.307l1.74,1.827c3.74-3.915,6.35-5.915,7.654-5.915c0.696,0,1.131,0.435,1.131,1.218
				c0,0.696-0.783,4.262-2.348,10.699l-8.177,34.36c-0.609,2.609-1.479,4.436-2.523,5.479c-1.044,1.045-2.697,1.653-4.958,1.915
				l-0.608,2.262c4.523-0.435,8.263-0.608,11.134-0.608c2.784,0,6.611,0.173,11.482,0.608l0.522-2.262
				c-4.175-0.521-6.872-1.131-8.177-1.915c-0.87-0.434-1.218-1.217-1.218-2.348c0-0.608,0.087-1.305,0.348-2.262l3.827-14.962
				c2.175,1.219,4.349,1.827,6.524,1.827c5.567,0,10.525-3.306,15.135-9.917c4.523-6.524,6.785-13.483,6.785-20.79
				C275.485,105.514,274.963,103.34,273.919,101.86z M264.96,127.522c-2.697,5.653-5.828,8.437-9.482,8.437
				c-2.522,0-4.958-1.131-7.306-3.567l2.435-9.829c0.87-3.827,1.914-6.524,2.958-8.089c1.479-2.175,3.566-4.436,6.437-6.611
				c1.74-1.392,3.393-2.088,4.871-2.088c1.304,0,2.262,0.434,3.044,1.304c0.783,0.871,1.131,2.175,1.131,3.915
				C269.048,116.387,267.743,121.868,264.96,127.522z"
        />
        <path
          fill={colors.accent}
          d="M297.318,105.95h9.395l0.696-3.219h-9.395l3.305-12.613l-7.22,2.697l-2.522,9.916h-7.394
				l-0.783,3.219h7.307l-4.61,18.006c-1.131,4.523-1.74,7.829-1.74,10.004c0,1.826,0.348,3.131,1.044,4.001
				c0.609,0.784,1.479,1.218,2.609,1.218c1.392,0,3.132-0.608,5.393-1.74c2.262-1.043,6.698-4.088,13.309-9.133l-1.74-2.088
				c-2.349,1.913-4.697,3.567-7.22,5.045c-2.001,1.131-3.392,1.652-4.349,1.652c-0.609,0-1.044-0.173-1.392-0.521
				c-0.348-0.347-0.522-0.957-0.522-1.739c0-1.827,0.609-4.958,1.827-9.481L297.318,105.95z"
        />
      </g>
      <path
        fill={colors.shadow}
        opacity="0.1"
        d="M466.854,42.449l-48.799,9.917c-0.957-1.566-1.74-2.783-2.088-3.654l-1.479-3.827
			c1.217-1.305,4.088-4.088,8.785-8.35c2.61-2.436,5.915-5.394,9.743-8.873c3.219-3.045,6.35-5.828,9.133-8.438
			c0.348-0.347,0.696-0.608,1.044-0.957h-31.402c-0.261,0.261-0.435,0.61-0.783,0.957c-1.566,2.089-3.393,4.436-5.48,7.132
			c-1.827-2.522-3.566-4.871-5.48-7.132c-0.261-0.347-0.522-0.608-0.783-0.957h-20.616c0.608,0.261,1.305,0.61,1.913,0.957
			c8.003,3.915,14.44,9.742,19.224,17.311c1.217,1.826,2.262,3.74,3.218,5.74c1.653,3.306,3.044,7.568,4.349,12.787l-49.495,10.091
			c-8.264,1.74-14.614,2.87-18.963,3.48c10.351,12.264,18.006,23.399,22.964,33.402l8.09-1.566
			c-1.914-3.566-2.697-6.263-2.349-7.915c0.261-1.739,1.304-2.958,3.131-3.827c1.914-0.958,8.786-2.697,20.703-5.22l43.406-9.047
			l50.191-10.438V38.709L466.854,42.449z M480.772,94.728c-1.044-2.262-2.784-3.741-5.045-4.523
			c-2.262-0.87-4.523-0.696-6.611,0.261c-1.653,0.87-3.044,2.088-4.088,3.653c-1.044,1.653-2.349,5.22-3.74,10.699
			c-2.958,10.873-9.047,18.529-18.354,23.053c-12.265,5.914-25.748,7.828-40.622,5.827c-6.959-0.957-13.831-2.958-20.79-5.915
			c-7.916-3.394-15.745-8.09-23.66-14.093c-14.788-11.222-25.922-24.704-33.49-40.361c-5.915-12.179-7.568-23.313-5.045-33.316
			c0.261-1.218,0.609-2.349,1.044-3.479c2.697-7.569,7.655-13.396,14.874-17.311c0.522-0.347,1.131-0.696,1.74-0.957h-34.882
			c-0.086,0.348-0.174,0.61-0.174,0.957c-0.435,1.914-0.696,3.828-0.87,5.915c-0.261,3.653-0.261,7.481,0.087,11.396
			c0.957,11.482,4.611,23.921,11.047,37.229c9.22,19.05,22.268,35.056,39.317,48.017c7.394,5.654,14.788,10.265,22.182,13.83
			c9.742,4.698,19.485,7.568,29.314,8.786c17.31,2.088,33.664-0.609,49.06-8.002c11.917-5.829,20.702-13.396,26.269-22.704
			C482.512,106.471,483.382,100.121,480.772,94.728z"
      />
      <g>
        <rect x="53.547" y="198.75" fill={colors.line} width="280.282" height="12.278" />
        <rect x="53.547" y="229.128" fill={colors.line} width="209.992" height="12.278" />
        <rect x="53.547" y="259.507" fill={colors.line} width="209.992" height="12.278" />
        <rect x="53.547" y="289.886" fill={colors.line} width="244.491" height="12.278" />
        <rect x="352.116" y="229.128" fill={colors.line} width="100.944" height="12.278" />
        <rect x="377.431" y="198.75" fill={colors.line} width="75.629" height="12.278" />
        <rect x="377.431" y="259.507" fill={colors.line} width="75.629" height="12.278" />
        <rect x="365.006" y="289.886" fill={colors.line} width="88.053" height="12.278" />
      </g>
      <g>
        <rect x="46.65" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="65.813" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="84.975" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="104.137" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="123.3" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="142.462" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="161.625" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="180.787" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="199.95" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="219.112" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="238.275" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="257.437" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="276.6" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="295.762" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="314.924" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="334.087" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="353.25" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="372.412" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="391.574" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="410.737" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="429.899" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
        <rect x="449.062" y="359.444" fill={colors.detail} width="10.895" height="4.661" />
      </g>
      <g>
        <rect x="146.731" y="395.237" fill={colors.detail} width="11.417" height="59.76" />
        <rect x="165.062" y="395.237" fill={colors.detail} width="8.377" height="59.76" />
        <rect x="180.352" y="395.237" fill={colors.detail} width="11.417" height="59.76" />
        <rect x="216.292" y="395.237" fill={colors.detail} width="6.781" height="59.76" />
        <rect x="198.684" y="395.237" fill={colors.detail} width="8.377" height="59.76" />
        <rect x="247.595" y="395.237" fill={colors.detail} width="11.417" height="59.76" />
        <rect x="232.305" y="395.237" fill={colors.detail} width="8.376" height="59.76" />
        <rect x="301.948" y="395.237" fill={colors.detail} width="3.574" height="59.76" />
        <rect x="335.57" y="395.237" fill={colors.detail} width="3.574" height="59.76" />
        <rect x="265.926" y="395.237" fill={colors.detail} width="8.377" height="59.76" />
        <rect x="314.837" y="395.237" fill={colors.detail} width="11.417" height="59.76" />
        <rect x="282.736" y="395.237" fill={colors.detail} width="8.377" height="59.76" />
        <rect x="348.458" y="395.237" fill={colors.detail} width="11.417" height="59.76" />
      </g>
    </g>
    <path
      fill={colors.foldShadow}
      opacity="0.1"
      d="M506.607,12.439v11.656c0,6.871-5.567,12.44-12.352,12.44h-9.221V512h-15.657
		l-4.349-11.221h-38.013L422.666,512h-30.358l-4.349-11.221h-38.013L345.596,512h-30.358l-4.436-11.221h-37.926L268.439,512h-30.271
		l-4.436-11.221h-37.926L191.369,512h-30.358l-4.349-11.221h-38.013L114.3,512H83.942l-4.349-11.221H41.58L37.23,512H21.572v-24.27
		L207.114,302.19l12.265-12.265l18.18-18.18l12.265-12.265l48.451-48.451l186.759-186.76l16.179-16.091l2.958-3.045
		C505.737,7.132,506.607,9.655,506.607,12.439z"
    />
  </g>
);

/** Newspaper / receipt illustration for scan-receipt actions. */
export const ScanReceiptNewspaperIcon = ({
  className = '',
  variant = 'default',
}: ScanReceiptNewspaperIconProps) => (
  <svg
    className={className}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    {variant === 'watermark' ? (
      <>
        <g className="dark:hidden" opacity="0.34">
          {renderNewspaper(WATERMARK_LIGHT_COLORS)}
        </g>
        <g className="hidden dark:block" opacity="0.32">
          {renderNewspaper(WATERMARK_DARK_COLORS)}
        </g>
      </>
    ) : (
      renderNewspaper(DEFAULT_COLORS)
    )}
  </svg>
);
